import { render, staticRenderFns } from "./AmbassadorTerms.vue?vue&type=template&id=5315daa1"
import script from "./AmbassadorTerms.vue?vue&type=script&lang=js"
export * from "./AmbassadorTerms.vue?vue&type=script&lang=js"
import style0 from "./AmbassadorTerms.vue?vue&type=style&index=0&id=5315daa1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports